module.exports = __webpack_public_path__ + "img/2016_alloottees_cebu.82041b32.jpg";